import { render, staticRenderFns } from "./blackList.vue?vue&type=template&id=673d1dd8&scoped=true"
import script from "./blackList.vue?vue&type=script&lang=js"
export * from "./blackList.vue?vue&type=script&lang=js"
import style0 from "./blackList.vue?vue&type=style&index=0&id=673d1dd8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673d1dd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673d1dd8')) {
      api.createRecord('673d1dd8', component.options)
    } else {
      api.reload('673d1dd8', component.options)
    }
    module.hot.accept("./blackList.vue?vue&type=template&id=673d1dd8&scoped=true", function () {
      api.rerender('673d1dd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/creditList/exposal/black/blackList.vue"
export default component.exports